import { buildInstanceWanda } from '@/api/instances'

const instanceWanda = buildInstanceWanda()
const instanceWandaWithoutTimeout = buildInstanceWanda(0)

const getHealthCareTeams = async store => {
  try {
    return await instanceWanda.get('healthcare_teams')
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'handoff/getHealthCareTeams',
        message: 'Ocorreu um erro ao obter a lista de times de saúde!'
      },
      { root: true }
    )
  }
}

const getReferenceTeam = async store => {
  try {
    return await instanceWanda.get('healthcare_additional_teams')
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'handoff/getReferenceTeam',
        message: 'Ocorreu um erro ao obter a lista de times de referência!'
      },
      { root: true }
    )
  }
}

const getMedicalHandOffReportFiltered = async (
  store,
  { filter, range, showError = true }
) => {
  try {
    const response = await instanceWanda.getResponse(
      'medical_hand_off/report',
      {
        params: {
          filter,
          range
        }
      }
    )
    const data = response.data
    return { response, data }
  } catch (error) {
    if (showError) {
      store.dispatch(
        'errors/setError',
        {
          error,
          request: 'handoff/getMedicalHandOffReportFiltered'
        },
        { root: true }
      )
    }

    return { data: null, response: null }
  }
}

const removeChannelFromMedicalHandOffReport = async (store, channelId) => {
  try {
    return await instanceWandaWithoutTimeout.delete(
      `medical_hand_off/report/${channelId}`
    )
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'handoff/removeChannelFromMedicalHandOffReport',
        message: 'Ocorreu um erro ao remover o canal da passagem de plantão!'
      },
      { root: true }
    )
  }
}

export default {
  getHealthCareTeams,
  getReferenceTeam,
  getMedicalHandOffReportFiltered,
  removeChannelFromMedicalHandOffReport
}
